<template>
    <div>
        <FormValidator form-group :validator="$v.form.name" v-slot="slotProps" :label="$t('name')" label-cols-sm="3">
            <b-form-input v-model="form.name" :state="slotProps.state" :disabled="loading" />
        </FormValidator>

        <FormValidator form-group :validator="$v.form.nameOnBuybox" v-slot="slotProps" :label="$t('campaignsSettings.nameOnBuybox')" label-cols-sm="3">
            <b-form-input v-model="form.nameOnBuybox" :state="slotProps.state" :disabled="loading" />
        </FormValidator>

        <FormValidator :validator="$v.form.url" v-slot="slotProps" form-group :label="$t('url')" label-cols-sm="3">
            <b-form-input v-model="form.url" :state="slotProps.state" :disabled="loading" />
        </FormValidator>

        <b-form-group :label="$t('advertiser')" label-cols-sm="3">
            <div v-if="item.advertiser" class="d-flex align-items-center h-100">{{ item.advertiser.name }}</div>
        </b-form-group>

        <b-form-group :label="$t('campaignsSettings.isActive')" label-cols-sm="3">
            <div class="d-flex align-items-center h-100">
                <b-checkbox v-model="form.isActive" switch size="lg" :disabled="loading" />
            </div>
        </b-form-group>
        <b-form-group :label="$t('campaignsSettings.isHidden')" label-cols-sm="3">
            <div class="d-flex align-items-center h-100">
                <b-checkbox v-model="form.hidden" switch size="lg" :disabled="loading" />
            </div>
        </b-form-group>
        <b-form-group :label="$t('campaignsSettings.textLinks')" label-cols-sm="3">
            <div class="d-flex align-items-center h-100">
                <b-checkbox v-model="form.notForTextLinks" switch size="lg" :disabled="loading" />
            </div>
        </b-form-group>
        <b-form-group :label="$t('campaignsSettings.filteredStatistics')" label-cols-sm="3">
            <div class="d-flex align-items-center h-100">
                <b-checkbox v-model="form.filteredStatistics" switch size="lg" :disabled="loading" />
            </div>
        </b-form-group>

        <div class="divider"></div>

        <FormValidator
            class="d-flex flex-column flex-grow-1"
            :validator="$v.formImages.logo"
            form-group
            label-cols-sm="3"
            :label="$t('campaignsSettings.logo')"
            v-slot="slotProps"
        >
            <div class="d-flex gap-2">
                <FormFile
                    v-model="formImages.logo"
                    accept="image/*"
                    show-thumbnails
                    :state="slotProps.state"
                    :disabled="loading"
                    :loading="requestImages.getLoading()"
                />
                <b-modal ref="formLogoModal" centered hide-footer hide-header body-class="text-center d-flex justify-content-center align-items-center">
                    <ImageLoader v-if="item" :src="item.logo" image-class="w-auto" style="max-width: 100%;" />
                </b-modal>
                <ImageLoader
                    v-if="item"
                    :src="item.logo"
                    class="my-auto cursor-pointer"
                    height="40px"
                    width="80px"
                    @click.native="$refs.formLogoModal.show()"
                />
            </div>
        </FormValidator>

        <FormValidator
            class="d-flex flex-column flex-grow-1"
            :validator="$v.formImages.icon"
            form-group
            label-cols-sm="3"
            :label="$t('campaignsSettings.icon')"
            v-slot="slotProps"
        >
            <div class="d-flex gap-2">
                <FormFile
                    v-model="formImages.icon"
                    accept="image/*"
                    show-thumbnails
                    :state="slotProps.state"
                    :disabled="loading"
                    :loading="requestImages.getLoading()"
                />
                <b-modal ref="formIconModal" centered hide-footer hide-header body-class="text-center d-flex justify-content-center align-items-center">
                    <ImageLoader v-if="item" :src="item.icon" image-class="w-auto" style="max-width: 100%;" />
                </b-modal>
                <ImageLoader
                    v-if="item"
                    :src="item.icon"
                    class="my-auto cursor-pointer"
                    height="40px"
                    width="80px"
                    @click.native="$refs.formIconModal.show()"
                />
            </div>
        </FormValidator>

        <div class="divider"></div>

        <b-form-group :label="$t('campaignsSettings.utmy')" label-cols-sm="3">
            <b-form-input v-model="form.extraParam" :disabled="loading" />
        </b-form-group>

        <FormValidator :validator="$v.form.cookieLifetime" v-slot="slotProps" form-group :label="$t('campaignsSettings.cookie')" label-cols-sm="3">
            <b-form-input v-model.number="form.cookieLifetime" :state="slotProps.state" :disabled="loading" />
        </FormValidator>

        <b-form-group :label="$t('campaignsSettings.textFields')" label-cols-sm="3">
            <b-form-input v-model="form.textFields" :disabled="loading" />
        </b-form-group>

        <div class="divider"></div>

        <b-form-group :label="$t('campaignsSettings.description')" label-cols-sm="3">
            <b-form-textarea v-model="form.description" rows="6" :disabled="loading" />
        </b-form-group>

        <b-form-group :label="$t('campaignsSettings.conditionDescription')" label-cols-sm="3">
            <b-form-textarea v-model="form.conditionDescription" rows="6" :disabled="loading" />
        </b-form-group>

        <div class="divider"></div>

        <b-form-group :label="$t('campaignsSettings.textLinkTargetUrlPattern')" label-cols-sm="3">
            <b-form-input v-model="form.textLinkTargetUrlPattern" :disabled="loading" />
        </b-form-group>

        <b-form-group :label="$t('campaignsSettings.textLinkRedirectUrlPattern')" label-cols-sm="3">
            <b-form-input v-model="form.textLinkRedirectUrlPattern" :disabled="loading" />
        </b-form-group>

        <div class="divider"></div>

        <b-form-group :label="$t('campaignsSettings.visibleFor')" label-cols-sm="3">
            <div class="d-flex flex-row align-items-center gap-4 h-100 w-100">
                <div v-if="requestUserRoles.getLoading()" class="d-flex justify-content-center flex-grow-1"><b-spinner /></div>
                <ErrorMessage v-else-if="requestUserRoles.getError()" :value="requestUserRoles.getError()" :dismissible="false" class="m-0" />
                <template v-else>
                    <b-checkbox v-for="(role, index) in formUserRolesFiltered" :key="index" :checked="!form.hiddenForRoles.includes(role.id)" :disabled="loading" @change="toggleRoleVisibility(role)">
                        {{ getRoleName(role.name) }}
                    </b-checkbox>
                </template>
            </div>
        </b-form-group>

        <b-form-group :label="$t('campaignsSettings.shopOnlyForCampaigns')" label-cols-sm="3">
            <div class="d-flex flex-column gap-3">
                <div v-if="requestShowSpaces.getLoading()" class="d-flex justify-content-center"><b-spinner /></div>
                <ErrorMessage v-else-if="requestShowSpaces.getError()" :value="requestShowSpaces.getError()" :dismissible="false" class="m-0" />
                <div v-else-if="formAddedSpaces.length" class="d-flex flex-wrap gap-2">
                    <b-badge v-for="(space, index) in formAddedSpaces" :key="index" variant="primary" class="btn d-flex align-items-center gap-1 font-size-14 text-white cursor-default" :class="{'disabled': loading}">
                        <span>{{ space.name }} ({{ space.categories.length }})</span>
                        <b-spinner v-if="requestShowSpacesAction.getLoading(`delete-${space.id}`)" small />
                        <feather
                            v-else
                            :class="{'cursor-pointer': !loading}"
                            type="trash-2"
                            size="16"
                            stroke="red"
                            @click="loading ? null : deleteShowSpace(space)"
                        />
                    </b-badge>
                </div>
                <div class="d-flex align-items-center gap-2">
                    <MultiselectSpaces v-model="formSelectedSpaces" :disabled-options="formAddedSpaces" :disabled="requestShowSpacesAction.getAnyLoading() || requestShowSpaces.getLoading() || loading" />
                    <ButtonIcon :disabled="!formSelectedSpaces.length || requestShowSpacesAction.getAnyLoading() || requestShowSpaces.getLoading() || loading" hide-label-while-loading @click="addSpace()"> {{ $t('addSpace') }} </ButtonIcon>
                </div>
            </div>
        </b-form-group>

        <div class="divider"></div>

        <div class="d-flex justify-content-end wide">
            <ButtonIcon :loading="loading" :disabled="requestShowSpacesAction.getAnyLoading() || requestShowSpaces.getLoading()" hide-label-while-loading class="wide" @click="save()">
                {{ $t('save') }}
            </ButtonIcon>
        </div>
    </div>
</template>



<script>
    import pick from 'lodash/pick';
    import cloneDeep from 'lodash/cloneDeep';
    import { serialize as objectToFormData } from 'object-to-formdata';
    import { helpers, required, integer } from 'vuelidate/lib/validators';
    import { image, url } from '@/utils/validators';
    import { deepMergeWithFilter, scrollToElement } from '@/utils/util';
    import MultiselectSpaces from '@/components/common/MultiselectSpaces.vue';
    import ImageLoader from '@/components/common/ImageLoader.vue';
    import FormValidator from '@/components/common/FormValidator.vue';
    import FormFile from '@/components/common/FormFile.vue';

    const FORM_DEFAULT_DATA = Object.freeze({
        name: '',
        nameOnBuybox: '',
        url: '',
        extraParam: '',
        cookieLifetime: '',
        textFields: '',
        description: '',
        conditionDescription: '',
        isActive: true,
        hidden: true,
        notForTextLinks: true,
        textLinkTargetUrlPattern: '',
        textLinkRedirectUrlPattern: '',
        filteredStatistics: true,
        hiddenForRoles: [],
    });

    const FORM_IMAGES_DEFAULT_DATA = Object.freeze({
        logo: null,
        icon: null,
    });

    export default {
        name: 'Settings',
        components: {
            MultiselectSpaces,
            ImageLoader,
            FormValidator,
            FormFile,
        },
        data() {
            return {
                requestCampaigns: this.$req('campaigns/Campaigns'),
                requestShowSpacesAction: this.$req('campaigns/ShowSpacesAction'),
                requestShowSpaces: this.$req('campaigns/ShowSpaces'),
                requestImages: this.$req('campaigns/Images'),
                requestUsers: this.$req('user/Users'),
                requestUserRoles: this.$req('user/UserRoles'),
                formSelectedSpaces: [],
                formAddedSpaces: [],
                formUserRoles: [],
                form: cloneDeep(FORM_DEFAULT_DATA),
                formImages: cloneDeep(FORM_IMAGES_DEFAULT_DATA),
            };
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        validations() {
            return {
                form: {
                    name: { required },
                    nameOnBuybox: { required },
                    cookieLifetime: { integer },
                    url: { url: val => !val || url(val) },
                },
                formImages: {
                    logo: { image: value => !helpers.req(value) || image(value) },
                    icon: { image: value => !helpers.req(value) || image(value) },
                },
            };
        },
        computed: {
            campaignId() {
                return this.parentComponent?.item?.id;
            },
            loading() {
                return this.requestCampaigns.getLoading();
            },
            item() {
                return this.parentComponent?.item || {};
            },

            formUserRolesFiltered() {
                return this.formUserRoles.filter(role => ['ROLE_WIDGETER', 'ROLE_PRODUCER'].includes(role.name));
            },
        },
        methods: {
            initFormValues() {
                const item = this.item;
                this.form = deepMergeWithFilter(FORM_DEFAULT_DATA, item);
                this.form.hiddenForRoles = item.excludeForRoles?.map(role => role.id) || [];
            },
            initFormImagesValues() {
                this.formImages = deepMergeWithFilter(FORM_IMAGES_DEFAULT_DATA, {});
            },
            toggleRoleVisibility(role) {
                const index = this.form.hiddenForRoles.indexOf(role.id);
                if (index > -1) {
                    this.form.hiddenForRoles.splice(index, 1);
                } else {
                    this.form.hiddenForRoles.push(role.id);
                }
            },
            async addSpace() {
                this.requestShowSpacesAction.resetAll();
                const promises = this.formSelectedSpaces.map(({ id }) => this.requestShowSpacesAction.id(`put-${id}`).put({ urlParams: { campaignId: this.campaignId, spaceId: id } }));
                await Promise.allSettled(promises);
                const requests = this.formSelectedSpaces.map(({ id }) => ({ id, ...this.requestShowSpacesAction.getState(`put-${id}`) }));
                const rejected = requests.filter(item => item.error);
                const fulfilled = requests.filter(item => !item.error);
                if (fulfilled.length && rejected.length) {
                    /* eslint-disable */
                    const vNodesMsg = this.$createElement('div', {}, [
                        this.$createElement('div', {}, [this.$t('successfullyAddedSomeSpace')]),
                        this.$createElement('div', {}, [`${this.$t('spacesWhichAErrorOccurred')}: ${rejected.map(({id}) => id).join(', ')}.`]),
                    ]);
                    /* eslint-enable */
                    this.$toastr.warning(vNodesMsg);
                    const rejectedIds = rejected.map(item => item.id);
                    this.formSelectedSpaces = this.formSelectedSpaces.filter(item => rejectedIds.includes(item.id));
                    await this.fetchSpaces();
                } else if (rejected.length) {
                    this.$toastr.error(this.$t('errorAddedSpaces'));
                } else if (fulfilled.length) {
                    this.$toastr.success(this.$t('successfullyAddedSpace'));
                    this.formSelectedSpaces = [];
                    await this.fetchSpaces();
                }
            },
            async deleteShowSpace(space) {
                await this.requestShowSpacesAction.id(`delete-${space.id}`).delete({ urlParams: { campaignId: this.campaignId, spaceId: space.id } });
                this.formAddedSpaces = this.formAddedSpaces.filter(item => item.id !== space.id);
            },
            getRoleName(role) {
                const roles = {
                    ROLE_ADMIN: this.$t('admin'),
                    ROLE_ADVERTISER: this.$t('advertiser'),
                    ROLE_PUBLISHER: this.$t('publisher'),
                    ROLE_WIDGETER: this.$t('widgeter'),
                    ROLE_SUPERADMIN: this.$t('superadmin'),
                    ROLE_PRODUCER: this.$t('producer'),
                };

                return roles[role] || role;
            },
            saveImages() {
                if (!this.formImages.icon && !this.formImages.logo) {
                    return;
                }
                const apiParams = {
                    urlParams: { campaignId: this.campaignId },
                    requestParams: objectToFormData(pick(this.formImages, ['icon', 'logo'])),
                    headers: { 'Content-Type': 'multipart/form-data' },
                };
                this.requestImages
                    .post(apiParams)
                    .then(({ logo, icon }) => {
                        if (logo) this.$set(this.parentComponent.item, 'logo', logo);
                        if (icon) this.$set(this.parentComponent.item, 'icon', icon);
                        this.initFormImagesValues();
                        this.$v.formImages.$reset();
                    })
                    .catch(error => this.$toastr.error(error.message, this.$t('errorOccurred')));
            },
            saveForm() {
                this.requestCampaigns
                    .patch({ urlParams: { id: this.campaignId }, requestParams: this.form })
                    .then(async responseForm => {
                        this.parentComponent.item = deepMergeWithFilter({ ...this.parentComponent.item, ...this.form }, responseForm);
                        this.$toastr.success(this.$t('dataSavedSuccessfully'));
                        this.initFormValues();
                        this.$v.form.$reset();
                    })
                    .catch(error => this.$toastr.error(error.message, this.$t('errorOccurred')));
            },
            async save() {
                this.$v.form.$touch();
                this.$v.formImages.$touch();
                if (this.$v.form.$invalid || this.$v.formImages.$invalid) {
                    await this.$nextTick();
                    scrollToElement('.is-invalid', { offset: -80 });
                    return;
                }
                this.saveForm();
                this.saveImages();
            },
            async fetchUserRoles() {
                this.formUserRoles = (await this.requestUserRoles.get())?.items || [];
            },
            async fetchSpaces() {
                this.formAddedSpaces = (await this.requestShowSpaces.get({ urlParams: { campaignId: this.campaignId } })) || [];
            },
        },
        created() {
            this.fetchUserRoles();
            this.fetchSpaces();
        },
        mounted() {
            this.initFormValues();
            this.initFormImagesValues();
        },
    };
</script>



<style lang="scss" scoped>
    .divider {
        height: 1px;
        width: 100%;
        margin-top: 2rem;
        margin-bottom: 2rem;
        background-color: #edeff4;
    }
</style>
